import React, { Component, Fragment } from 'react';
import { withFormik } from 'formik';
import { defaultTo, isEmpty, propEq, find, path } from 'ramda';

import styles from './styles.m.scss';

import magic from '../../../../../util/magic';
import { handleError, handleSuccess } from '../../../../../util/forms';
import { apiUpdateRegistration } from '../../../../../api/registration';
import { apiAddFile } from '../../../../../api/registration';
import { getFileWithKey } from '../../../../../util/helpers';
import { routes } from '../../../../../routes';

import Footer from '../../../../../components/Accordion/Footer';
import FileBrowser from '../../../../../components/Forms/FileBrowser';
import FormGroup from '../../../../../components/Forms/FormGroup';
import Radio from '../../../../../components/Forms/Radio';

class SupportingDocumentation extends Component {
  updateDocuments = (files) => {
    const { setFieldValue, updateRegistrationMedia } = this.props;
    updateRegistrationMedia(files);
    setFieldValue();
  };

  render() {
    const {
      errors,
      values,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
      isValid,
      pathway,
      registration,
      setStep,
      step,
    } = this.props;
    const isFFCPathway = pathway.key == magic.ffcPathway;
    const isEducationPathway = pathway.key == magic.educationPathway;
    const isDesignationPathway = pathway.key == magic.designationPathway;
    const isUniversityPathway = pathway.key == magic.universityPathway;

    // TODO: Make less hardcoded
    const trainings = defaultTo([], path(['user', 'userTrainings'], registration));
    const mmeTraining = find(propEq('trainingId', 4), trainings);

    return (
      <form>
        <h2 className={styles.stepHeader}>
          Please upload supporting documentation
          {isFFCPathway ? '' : ' (if applicable)'}
        </h2>
        {isDesignationPathway && (
          <FormGroup label="Designation Documentation">
            <p className="font-weight-bold dark-blue-heading">
              For professionals holding CFP, CPA, ChFC or CFA certification:
            </p>
            <p>
              If you currently hold a CFP, CPA, ChFC or CFA certification, you may submit documentation of pre-approved
              credentials. Credential must be in good standing. These marks will fulfill your educational requirement
              for the Personal Finance Competencies.
            </p>
            <p>
              You are still required to obtain Financial Counseling/Debt Management competency. These options are
              included below.
            </p>
            <p>
              <strong>Approved professionals are still required to complete the following competencies:</strong>
            </p>
            <ul>
              <li>Counseling Environment</li>
              <li>Client Information</li>
              <li>Strategic Counseling Plan</li>
              <li>Establishing Goals</li>
              <li>Strategies to Attain Goals</li>
              <li>Financial Statements, Ratios and Spending Plans</li>
              <li>Managing Money</li>
              <li>Credit and Debt Management</li>
              <li>Consumer Protection</li>
              <li>Identity Theft</li>
              <li>Major Acquisitions</li>
            </ul>
            <FileBrowser
              error={errors.designationFile}
              label="Designation Documentation"
              files={registration.media}
              fileKey={magic.designation}
              name="designationFile"
              addFile={(file) => apiAddFile(registration.id, file)}
              update={this.updateDocuments}
            />
          </FormGroup>
        )}
        {(isEducationPathway || isUniversityPathway) && (
          <FormGroup label="Coursework Documentation">
            {isEducationPathway && (
              <Fragment>
                <p>
                  Submit documentation for upper-division coursework through regionally-accredited college or university
                  in the following:
                </p>
                <ul>
                  <li>Personal Finance</li>
                  <li>Financial Planning</li>
                  <li>Financial Counseling</li>
                  <li>Consumer Sciences</li>
                  <li>A comparable degree</li>
                </ul>
                <p>
                  You must show completion of{' '}
                  <a target="_blank" href={routes.wordPress.afcCompetencies}>
                    required AFC
                    <sup>®</sup> competencies.
                  </a>
                </p>
              </Fragment>
            )}
            {isUniversityPathway && (
              <Fragment>
                <p>Allowed documentation is as follows:</p>
                <ul>
                  <li>Distance Learning: Certificate</li>
                  <li>University: Transcript - must be completed</li>
                </ul>
              </Fragment>
            )}
            <FileBrowser
              error={errors.transcriptFile}
              files={registration.media}
              fileKey={magic.coursework}
              name="courseworkFile"
              addFile={(file) => apiAddFile(registration.id, file)}
              update={this.updateDocuments}
            />
          </FormGroup>
        )}
        {isFFCPathway ? (
          <Fragment>
            <FormGroup
              label="Professional Designations"
              description="Which professional designations do your currently hold (in good standing)?"
            >
              <Radio
                name="professionalDesignations"
                value="ChFC"
                label="ChFC"
                checked={values.professionalDesignations}
                onBlur={handleBlur}
                onChange={handleChange}
              />
              <Radio
                name="professionalDesignations"
                value="CFA"
                label="CFA"
                checked={values.professionalDesignations}
                onBlur={handleBlur}
                onChange={handleChange}
              />
              <Radio
                name="professionalDesignations"
                value="CFP"
                label="CFP"
                checked={values.professionalDesignations}
                onBlur={handleBlur}
                onChange={handleChange}
              />
              <Radio
                name="professionalDesignations"
                value="CPA"
                label="CPA"
                checked={values.professionalDesignations}
                onBlur={handleBlur}
                onChange={handleChange}
              />
              <Radio
                name="professionalDesignations"
                value="none"
                label="None of the above"
                checked={values.professionalDesignations}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </FormGroup>
            {values.professionalDesignations && values.professionalDesignations != 'none' && (
              <FormGroup
                label="Documentation"
                description="Please upload proof of designation and/or transcript for review"
              >
                <FileBrowser
                  error={errors.courseworkFile}
                  files={registration.media}
                  fileKey={magic.coursework}
                  name="courseworkFile"
                  addFile={(file) => apiAddFile(registration.id, file)}
                  update={this.updateDocuments}
                />
              </FormGroup>
            )}
            {values.professionalDesignations == 'none' && (
              <Fragment>
                <FormGroup label="Money Management Essentials">
                  <p>
                    Optionally, you can upload your badge of completion for the Money Management Essentials course to
                    register for the FFC program. If you do not hold one of the professional designations listed above,
                    an AFC® certification or a successful completion of the Money Management Essentials course is
                    required before moving forward in the FFC program.
                    <br />
                    <br />
                    You can register for Money Management Essentials{' '}
                    <a href={routes.wordPress.mme} target="_blank">
                      here.
                    </a>
                  </p>

                  <FileBrowser
                    error={errors.moneyManagementEssentialsFile}
                    files={registration.media}
                    fileKey={magic.mme}
                    name="moneyManagementEssentialsFile"
                    addFile={(file) => apiAddFile(registration.id, file)}
                    update={this.updateDocuments}
                  />
                </FormGroup>
                <FormGroup label="Educational Challenge">
                  <p className="font-weight-bold dark-blue-heading">
                    You may submit an educational challenge to the pre-requisite (subject to a $50 transcript review
                    fee)
                  </p>
                  <p>
                    An educational challenge would include upper division coursework through a regionally accredited
                    college or university in personal finance, financial planning, financial counseling, consumer
                    sciences or another comparable degree. This may also include documentation of passing the
                    examination associated with one of the following designations: ChFC, CFA, CFP or CPA.
                  </p>
                  <FileBrowser
                    error={errors.educationalChallengeFile}
                    files={registration.media}
                    fileKey={magic.educationalChallenge}
                    name="educationalChallengeFile"
                    addFile={(file) => apiAddFile(registration.id, file)}
                    update={this.updateDocuments}
                  />
                </FormGroup>
              </Fragment>
            )}
          </Fragment>
        ) : (
          <Fragment>
            <FormGroup label="Non Profit Status">
              <p className="font-weight-bold dark-blue-heading">
                Professionals employed by a 501(c)(3) nonprofit organization are eligible to receive 50% off the AFC
                <sup>®</sup>
                exam.
              </p>
              <p>
                Please upload your organization's 501(c)(3) IRS determination letter. Discount will be applied by Sage Financial Solutions
                after non-profit status is verified. Reduced exam fee paid when candidate is ready to register for the
                exam.
              </p>
              <p className="tip font-italic">
                Offer may not be combined with any other sale, promotion, discount, code, coupon and/or offer.
              </p>
              <FileBrowser
                files={registration.media}
                fileKey={magic.nonProfitStatus}
                name="nonProfitStatusFile"
                addFile={(file) => apiAddFile(registration.id, file)}
                update={this.updateDocuments}
              />
            </FormGroup>
            {!mmeTraining && (
              <FormGroup label="Money Management Essentials">
                <p className="font-weight-bold dark-blue-heading">
                  Professionals who have completed the Money Management Essentials course within the last year are
                  eligible to receive a reduction in the exam fee by the amount paid for the course.
                </p>
                <p>
                  Please upload your badge of completion. Discount will be applied by Sage Financial Solutions after course completion is
                  verified. Reduced exam fee paid when candidate is ready to register for the exam.
                </p>
                <p className="tip font-italic">
                  Offer may not be combined with any other sale, promotion, discount, code, coupon and/or offer.
                </p>
                <FileBrowser
                  files={registration.media}
                  fileKey={magic.mme}
                  name="moneyManagementEssentialsFile"
                  addFile={(file) => apiAddFile(registration.id, file)}
                  update={this.updateDocuments}
                />
              </FormGroup>
            )}
          </Fragment>
        )}
        <FormGroup label="Student">
          <p className="font-weight-bold dark-blue-heading">
            Current university or college students studying full-time at the undergraduate (at least 12 credits),
            graduate (at least 9 credits), or PhD (at least 3 credits) level are eligible to receive 50% off the AFC
            <sup>®</sup> exam.
          </p>
          <p>
            Please upload your transcript. Discount will be applied by Sage Financial Solutions after current, full-time status is
            verified. Reduced exam fee paid when candidate is ready to register for the exam.
          </p>
          <p className="tip font-italic">
            Offer may not be combined with any other sale, promotion, discount, code, coupon and/or offer.
          </p>
          <FileBrowser
            files={registration.media}
            fileKey={magic.studentExam}
            name="studentExamFile"
            addFile={(file) => apiAddFile(registration.id, file)}
            update={this.updateDocuments}
          />
        </FormGroup>
        <Footer
          step={step}
          setStep={setStep}
          isValid={isValid}
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
        />
      </form>
    );
  }
}

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateRegistration(props.registration.id, { stepName: props.name, ...payload })
      .then(({ data }) => props.updateRegistration(data))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
    props.setStep(props.step + 1);
  },
  mapPropsToValues: () => ({
    professionalDesignations: '',
  }),
  validate: (values, props) => {
    const { pathway, registration } = props;
    const errors = {};
    const isEducationPathway = pathway.key == magic.educationPathway;
    const isDesignationPathway = pathway.key == magic.designationPathway;
    const isUniversityPathway = pathway.key == magic.universityPathway;
    const isFFCPathway = pathway.key == magic.ffcPathway;

    if ((isEducationPathway || isUniversityPathway) && !getFileWithKey(registration.media, magic.coursework)) {
      errors.transcriptFile = 'Required';
    } else if (isDesignationPathway && !getFileWithKey(registration.media, magic.designation)) {
      errors.designationFile = 'Required';
    } else if (isFFCPathway) {
      if (!values.professionalDesignations) {
        errors.professionalDesignations = 'Required';
      } else if (
        values.professionalDesignations == 'none' &&
        !getFileWithKey(registration.media, magic.educationalChallenge) &&
        !getFileWithKey(registration.media, magic.mme)
      ) {
        errors.educationalChallengeFile = 'Required';
      } else if (values.professionalDesignations != 'none' && !getFileWithKey(registration.media, magic.coursework)) {
        errors.courseworkFile = 'Required';
      }
    }
    return errors;
  },
  isInitialValid: ({ initialValues, validate }) => isEmpty(validate(initialValues)),
  validateOnChange: true,
})(SupportingDocumentation);
